import { combineReducers } from 'redux';
import { authReducer } from './auth/reducer';
import { configReducer } from './config/reducer';
import { modalReducer } from './modal/reducer';
import { navReducer } from './nav/reducer';
import { oauthReducer } from './oauth/reducer';
import { scrollReducer } from './scrollPage/reducer';
import { userReducer } from './user/reducer';
const reducerMap = {
  auth: authReducer,
  config: configReducer,
  modal: modalReducer,
  nav: navReducer,
  oauth: oauthReducer,
  user: userReducer,
  scrollPage: scrollReducer
};
export const rootReducer = combineReducers(reducerMap);